
















































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storePasien } from "@/store/modules/pasien";
import TandaVitalSvc from "@/services/TandaVital";
import http from "@/axios/http-common";
import moment from "moment";
import EwssAnakScoringMatrix from "./ewssanak/EwssAnakScoringMatrix.vue";

@Component({
  components: {
    EwssAnakScoringMatrix
  }
})
export default class EwssAnakPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: false }) isActive!: boolean;

  dataList: any[] = [];
  loading = false;
  editingId: number | null = null;
  editTindakLanjutValue = "";

  readonly sianosisText: Record<string, string> = {
    "1": "Tidak",
    "2": "Pucat",
    "3": "Sianotik",
    "4": "Sianotik+Motlet"
  };

  readonly kesadaranText: Record<string, string> = {
    cm: "CM",
    apatis: "Apatis",
    delirium: "Delirium",
    somnolen: "Somnolen",
    iritable: "Iritable",
    letargi: "Letargi",
    gelisah: "Gelisah",
    sopor: "Sopor",
    "semi-coma": "Semi-koma",
    coma: "Koma"
  };

  readonly usiaReferensi = [
    { label: "Neonatus", rentang: "0 - 1 bulan", nadi: "100 - 180", nafas: "40 - 60" },
    { label: "Bayi", rentang: "1 - 12 bulan", nadi: "100 - 180", nafas: "35 - 40" },
    { label: "Balita", rentang: "13 - 47 bulan", nadi: "70 - 110", nafas: "25 - 30" },
    { label: "Pra Sekolah", rentang: "4 - 6 tahun", nadi: "70 - 110", nafas: "21 - 23" },
    { label: "Sekolah", rentang: "7 - 12 tahun", nadi: "70 - 110", nafas: "19 - 21" },
    { label: "Remaja", rentang: "13 - 19 tahun", nadi: "55 - 90", nafas: "16 - 18" }
  ];

  readonly headers = [
    { text: "Waktu", value: "waktu_periksa", width: "120px" },
    { text: "Sianosis", value: "sianosis", sortable: false },
    { text: "CRT", value: "kapiler", sortable: false },
    { text: "Nadi", value: "frekuensi_nadi", sortable: false },
    { text: "Kardio", value: "ews_anak_kardiovaskuler_skor", sortable: false },
    { text: "RR", value: "frekuensi_nafas", sortable: false },
    { text: "Retraksi", value: "retraksi", sortable: false },
    { text: "O2 (% / L)", value: "suplemeno2", sortable: false },
    { text: "Resp", value: "ews_anak_respirasi_skor", sortable: false },
    { text: "Kesadaran", value: "kesadaran", sortable: false },
    { text: "KU", value: "ews_anak_kesadaran_skor", sortable: false },
    { text: "Total", value: "ews_anak_skor", sortable: false },
    { text: "Kategori", value: "kategori", sortable: false },
    { text: "Tindak Lanjut", value: "ewss_tindak_lanjut", sortable: false, width: "150px" },
    { text: "Perawat", value: "user", sortable: false }
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get kelompokUsiaLabel(): string {
    if (!this.pasien?.tgl_lahir) return "-";
    // tgl_lahir format: "DD-MM-YYYY"
    const tglLahir = moment(this.pasien.tgl_lahir, "DD-MM-YYYY");
    const now = moment();
    const th = now.diff(tglLahir, "years");
    const bln = now.diff(tglLahir, "months");
    const hr = now.diff(tglLahir, "days");

    if (th === 0 && bln === 0 && hr <= 28) return "Neonatus";
    if (bln <= 12) return "Bayi";
    if (bln <= 47) return "Balita";
    if (th >= 4 && th <= 6) return "Pra Sekolah";
    if (th >= 7 && th <= 12) return "Sekolah";
    if (th >= 13 && th <= 19) return "Remaja";
    return "-";
  }

  get normalRange() {
    const label = this.kelompokUsiaLabel;
    const ref = this.usiaReferensi.find(r => r.label === label);
    if (!ref) return { nadi: { min: null, max: null }, nafas: { min: null, max: null } };
    const parseRange = (s: string) => {
      const parts = s.split("-").map(p => parseInt(p.trim()));
      return { min: parts[0], max: parts[1] };
    };
    return { nadi: parseRange(ref.nadi), nafas: parseRange(ref.nafas) };
  }

  get latestVitals(): any | null {
    if (!this.dataList.length) return null;
    // dataList sorted desc by waktu_periksa
    const sorted = [...this.dataList].sort(
      (a, b) => new Date(b.waktu_periksa).getTime() - new Date(a.waktu_periksa).getTime()
    );
    return sorted[0];
  }

  get eskalasi() {
    if (!this.latestVitals) {
      return { color: "grey", type: "info", title: "", text: "", prominent: false };
    }

    if (this.latestVitals.henti_jantung === "y") {
      return {
        color: "blue",
        type: "error",
        title: "HENTI JANTUNG",
        text: "RJP + Aktivasi 666, Tim Primer maks 5 menit",
        prominent: true
      };
    }

    const skor = this.latestVitals.ews_anak_skor;
    if (skor >= 5) {
      return {
        color: "red",
        type: "error",
        title: "KRITIS",
        text: "Aktivasi Tim Sekunder (777/888), respons maks 10 menit",
        prominent: true
      };
    }
    if (skor >= 3) {
      return {
        color: "orange",
        type: "warning",
        title: "RISIKO SEDANG",
        text: "Monitoring tiap 1 jam, konsultasi DPJP",
        prominent: false
      };
    }
    return {
      color: "green",
      type: "success",
      title: "RISIKO RINGAN",
      text: "Pasien stabil, evaluasi tiap 4 jam",
      prominent: false
    };
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val) this.loadData();
  }

  mounted() {
    if (this.isActive) this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const resp = await TandaVitalSvc.getByRegister(this.register, {
        sortBy: "waktu_periksa",
        sortDesc: true
      });
      const items = resp.data || resp;
      this.dataList = (Array.isArray(items) ? items : items.data || []).filter(
        (item: any) => item.ews_cat === "ank"
      );
    } catch (e) {
      console.error("Error loading EWSS Anak data", e);
    } finally {
      this.loading = false;
    }
  }

  formatDate(dt: string): string {
    return moment(dt).format("DD/MM/YY HH:mm");
  }

  skorCellColor(skor: number): string {
    if (skor >= 3) return "red";
    if (skor >= 2) return "orange";
    if (skor >= 1) return "amber darken-2";
    return "green";
  }

  totalSkorColor(item: any): string {
    if (item.henti_jantung === "y") return "blue";
    const s = item.ews_anak_skor;
    if (s >= 5) return "red";
    if (s >= 3) return "orange";
    return "green";
  }

  getKategori(item: any): string {
    if (item.henti_jantung === "y") return "Henti Jantung";
    const s = item.ews_anak_skor;
    if (s >= 5) return "Kritis";
    if (s >= 3) return "Sedang";
    return "Ringan";
  }

  startEditTindakLanjut(item: any) {
    this.editingId = item.id;
    this.editTindakLanjutValue = item.ewss_tindak_lanjut || "";
  }

  async saveTindakLanjut(item: any) {
    if (this.editingId !== item.id) return;

    try {
      await TandaVitalSvc.update(item.id, {
        ...this.buildUpdateParams(item),
        ewss_tindak_lanjut: this.editTindakLanjutValue
      });
      item.ewss_tindak_lanjut = this.editTindakLanjutValue;
    } catch (e) {
      console.error("Error saving tindak lanjut", e);
    } finally {
      this.editingId = null;
    }
  }

  buildUpdateParams(item: any) {
    return {
      pasien_rm: item.pasien_rm || item.rm_dash,
      register_id: item.register_id,
      unit_id: item.unit?.id,
      sistole: item.sistole,
      diastole: item.diastole,
      frekuensi_nadi: item.frekuensi_nadi,
      frekuensi_nafas: item.frekuensi_nafas,
      suhu_badan: item.suhu_badan,
      saturasi_oksigen: item.saturasi_oksigen,
      keadaan_umum: item.keadaan_umum,
      kesadaran: item.kesadaran,
      waktu_periksa: item.waktu_periksa,
      henti_jantung: item.henti_jantung,
      periksa_tensi: item.periksa_tensi,
      suplemeno2: item.suplemeno2,
      gds: item.gds,
      urin_output: item.urin_output,
      urin_output_satuan: item.urin_output_satuan,
      nadi: item.nadi,
      sianosis: item.sianosis,
      retraksi: item.retraksi,
      kapiler: item.kapiler,
      ews_cat: item.ews_cat
    };
  }

  cetakPdf() {
    window.open(`${http.getAPI()}/ewss-anak/${this.register}/pdf`, "_blank");
  }
}
